__turbopack_context__.v({
  "apply": "careers-module__G5hdYq__apply",
  "applyButton": "careers-module__G5hdYq__applyButton",
  "back": "careers-module__G5hdYq__back",
  "browser": "careers-module__G5hdYq__browser",
  "categories": "careers-module__G5hdYq__categories",
  "detail": "careers-module__G5hdYq__detail",
  "empty": "careers-module__G5hdYq__empty",
  "filterRow": "careers-module__G5hdYq__filterRow",
  "filters": "careers-module__G5hdYq__filters",
  "heading": "careers-module__G5hdYq__heading",
  "locationNote": "careers-module__G5hdYq__locationNote",
  "locations": "careers-module__G5hdYq__locations",
  "page": "careers-module__G5hdYq__page",
  "position": "careers-module__G5hdYq__position",
  "results": "careers-module__G5hdYq__results",
  "search": "careers-module__G5hdYq__search",
  "status": "careers-module__G5hdYq__status",
});
